module.exports = __webpack_public_path__ + "media/bootstrap-icons/view-list-7dbbb6b5.svg";